import { STATUS_NULL_FILTER } from '@seller-area/components/molecules/company-details/unit-details-drawer/constants';

import { GruposReportFilters } from './types';

export const buildGruposReportFilterFields = (filters: GruposReportFilters) => {
  return {
    term: filters.term || undefined,
    nameFilter: filters.nameFilter || undefined,
    clientIdFilter: filters.clientIdFilter || undefined,
    legalNameFilter: filters.legalNameFilter || undefined,
    docTypeFilter: filters.docType ?? undefined,
    docNumberFilter: filters.docNumberFilter || undefined,
    exposure: filters.exposure ?? undefined,
    profile: filters.profile ?? undefined,
    status: filters.status && filters.status !== STATUS_NULL_FILTER ? filters.status : undefined,
    statusIsNull: filters.status === STATUS_NULL_FILTER ? true : undefined,
    crmIdFilter: filters.crmIdFilter || undefined,
    accountManagerIdFilter: filters.accountManagerIdFilter || undefined,
    clientSinceFrom: filters.clientSinceRange?.from ?? undefined,
    clientSinceTo: filters.clientSinceRange?.to ?? undefined,
    churnDateFrom: filters.churnDateRange?.from ?? undefined,
    churnDateTo: filters.churnDateRange?.to ?? undefined,
    createdAtFrom: filters.createdAtRange?.from ?? undefined,
    createdAtTo: filters.createdAtRange?.to ?? undefined,
    updatedAtFrom: filters.updatedAtRange?.from ?? undefined,
    updatedAtTo: filters.updatedAtRange?.to ?? undefined,
    volumeMwmMin: filters.volumeMwmRange?.min ?? undefined,
    volumeMwmMax: filters.volumeMwmRange?.max ?? undefined,
    exposurePercentageMin: filters.exposurePercentageRange?.min ?? undefined,
    exposurePercentageMax: filters.exposurePercentageRange?.max ?? undefined,
    companiesCountMin: filters.companiesCountRange?.min ?? undefined,
    companiesCountMax: filters.companiesCountRange?.max ?? undefined,
    unitsCountMin: filters.unitsCountRange?.min ?? undefined,
    unitsCountMax: filters.unitsCountRange?.max ?? undefined,
  };
};

export const buildGruposReportGraphqlVariables = (
  page: number,
  limit: number,
  filters: GruposReportFilters,
  sortBy: string | null,
  sortOrder: 'asc' | 'desc',
  nullKpi: string | null = null,
) => ({
  page,
  limit,
  ...buildGruposReportFilterFields(filters),
  sortBy: sortBy ?? undefined,
  sortOrder: sortBy ? sortOrder : undefined,
  nullKpi: nullKpi ?? undefined,
});

const EXPORT_PARAM_KEYS: Record<string, string> = {
  term: 'term',
  nameFilter: 'name_filter',
  clientIdFilter: 'client_id_filter',
  legalNameFilter: 'legal_name_filter',
  docTypeFilter: 'doc_type_filter',
  docNumberFilter: 'doc_number_filter',
  exposure: 'exposure',
  profile: 'profile',
  status: 'status',
  crmIdFilter: 'crm_id_filter',
  accountManagerIdFilter: 'account_manager_id_filter',
  clientSinceFrom: 'client_since_from',
  clientSinceTo: 'client_since_to',
  churnDateFrom: 'churn_date_from',
  churnDateTo: 'churn_date_to',
  createdAtFrom: 'created_at_from',
  createdAtTo: 'created_at_to',
  updatedAtFrom: 'updated_at_from',
  updatedAtTo: 'updated_at_to',
  volumeMwmMin: 'volume_mwm_min',
  volumeMwmMax: 'volume_mwm_max',
  exposurePercentageMin: 'exposure_percentage_min',
  exposurePercentageMax: 'exposure_percentage_max',
  companiesCountMin: 'companies_count_min',
  companiesCountMax: 'companies_count_max',
  unitsCountMin: 'units_count_min',
  unitsCountMax: 'units_count_max',
};

export const appendGruposReportExportParams = (
  params: URLSearchParams,
  filters: GruposReportFilters,
  nullKpi: string | null = null,
) => {
  const fields = buildGruposReportFilterFields(filters);

  Object.entries(EXPORT_PARAM_KEYS).forEach(([sourceKey, targetKey]) => {
    const value = fields[sourceKey as keyof typeof fields];
    if (value != null && value !== '') {
      params.append(targetKey, String(value));
    }
  });

  if (nullKpi) {
    params.append('null_kpi', nullKpi);
  }
};
